import React from 'react';
import config from '../../util/js/config';
// import Explainer1 from './1/Explainer1';
import Explainer2 from './2/Explainer2';

import Radium from 'radium';

const ExplainerArray = {
    // "1": Explainer1,
    "2": Explainer2
}

class Explainer extends React.Component {
    render() {
        const explainerConfig = config.explainer || 1;
        const ExplainerView = ExplainerArray[explainerConfig]
        return (
            <ExplainerView />
        );
    }
};

export default Radium(Explainer);




// WEBPACK FOOTER //
// ./src/components/Explainer/Explainer.js